// Notice Storage -- uploads notice HTML to Cloudflare R2 via presigned URL
// Uses the same r2-upload Edge Function as DocumentsTab

import { supabase } from "./supabase";

const R2_FUNCTION_URL = process.env.REACT_APP_SUPABASE_FUNCTION_URL
  ? process.env.REACT_APP_SUPABASE_FUNCTION_URL.replace("stripe-payout", "r2-upload")
  : "";

/**
 * Upload a notice HTML string to Cloudflare R2
 * Returns { fileUrl, storagePath } or throws
 */
export const uploadNoticeToR2 = async (htmlContent, noticeType, tenantName) => {
  if (!R2_FUNCTION_URL) {
    console.warn("R2 not configured -- notice HTML will not be stored in R2");
    return { fileUrl: null, storagePath: null };
  }

  try {
    const session = await supabase.auth.getSession();
    const token   = session?.data?.session?.access_token || "";

    const safeName   = (tenantName || "tenant").replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_-]/g, "");
    const safeType   = (noticeType || "notice").replace(/\s+/g, "-").replace(/[^a-zA-Z0-9_-]/g, "");
    const fileName   = `${safeType}_${safeName}_${Date.now()}.html`;
    const folder     = "notices";

    // Get presigned URL from Edge Function
    const res = await fetch(R2_FUNCTION_URL, {
      method: "POST",
      headers: {
        "Content-Type":  "application/json",
        "Authorization": `Bearer ${token}`,
        "apikey":        process.env.REACT_APP_SUPABASE_ANON_KEY || "",
      },
      body: JSON.stringify({ fileName, fileType: "text/html", folder }),
    });

    if (!res.ok) throw new Error("Failed to get R2 presigned URL");
    const { presignedUrl, fileUrl, key } = await res.json();

    // Upload HTML directly to R2
    const uploadRes = await fetch(presignedUrl, {
      method:  "PUT",
      headers: { "Content-Type": "text/html" },
      body:    htmlContent,
    });

    if (!uploadRes.ok) throw new Error("R2 upload failed");

    return { fileUrl, storagePath: key };
  } catch (err) {
    console.error("Notice R2 upload failed:", err);
    return { fileUrl: null, storagePath: null };
  }
};
